import LangSelector from "@/features/LangSelector/LangSelector"
import LoadingSpinner from "@/features/LoadingSpinner/LoadingSpinner"
import { Outlet } from "react-router-dom"
import logo from "/src/assets/logo.png"
import { renderDLAPP } from "@/assets/dlapp"
import { Fragment } from "react"
import facebookIcon from "/src/assets/facebook.png"
import instagramIcon from "/src/assets/instagram.png"
import whatsappIcon from "/src/assets/whatsapp.png"

export default function Layout() {
  const t = useTranslate()
  const footerItems = [
    { heading: "sales", email: "sales@storellet.com" },
    { heading: "mkt", email: "marketing@storellet.com" },
    { heading: "techsupport", email: "support@storellet.com" },
  ]

  const socialMedia = [
    { icon: facebookIcon, link: "https://www.facebook.com/storellet" },
    { icon: instagramIcon, link: "https://www.instagram.com/storellet" },
    { icon: whatsappIcon, link: "https://wa.me/+85254200508?text=" },
  ]

  return (
    <div className="min-h-screen flex flex-col bg-[rgb(244,244,244)]">
      <LoadingSpinner />
      <header className="w-full">
        <div className="flex py-2 px-4 lg:py-2 lg:px-8 justify-between items-center">
          <img className="h-6 lg:h-8 object-contain" src={logo} alt="Logo" />
          <LangSelector />
        </div>
      </header>
      <main className="container mx-auto text-center flex-grow flex flex-col justify-around">
        <Outlet />
      </main>
      <footer className="bg-[rgb(235,235,235)]">
        <div className="container mx-auto py-6 flex flex-wrap">
          <div className="w-full lg:w-1/2">
            {footerItems.map((f) => (
              <Fragment key={`footer-${f.heading}-heading`}>
                <div className="my-1 font-bold text2">{t(f.heading)}</div>
                <div className="my-1" key={`footer-${f.heading}-mail`}>
                  <a className="text2 underline" href={`mailto:${f.email}`}>
                    {f.email}
                  </a>
                </div>
              </Fragment>
            ))}
            <Fragment key="footer-download">
              <div className="my-1 font-bold text2">{t("downloadApp")}</div>
            </Fragment>
            <div className="my-1">
              {renderDLAPP({ onClick: () => {}, centered: false })}
            </div>
            <div className="flex flex-row mt-4">
              {socialMedia.map((s) => (
                <a
                  key={`footer-${s.icon}`}
                  className="mx-2"
                  href={s.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={s.icon}
                    alt={`${s.link} icon`}
                    className="h-8 w-8"
                  />
                </a>
              ))}
            </div>
            <div className="w-full mt-4 text2">
              {t("copyright1")}
              {t("copyright2")}
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
